import { useState } from "react";
import { useEffect } from "react";
import { Fragment } from "react";
import { connect } from "react-redux";

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Grid, lighten, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import * as BotpressAPI from "../../data/api/omniBotpressAPI.js";
import * as BotpressSessionActions from "../../state/redux/botpressSession.js";

const QuestionForBotpressDisplay = props => {
  const {
    botpressBotODM,
    question,
    onAnswerSelected,
    startNextTimer,
    assessmentConversationId,
    assessmentUserKey,
  } = props;

  const theme = useTheme();

  const defaultDelay = 50;

  //just manages state
  const [localAnswer, setLocalAnswer] = useState(question.answerValue ? question.answerValue : []);

  //just manages state
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (question.answerValue) {
      setLocalAnswer(question.answerValue);
    }
  }, [question, setLocalAnswer]);

  useEffect(() => {
    if (assessmentConversationId != null && assessmentUserKey != null && sending === false) {
      //send message

      setSending(true).then(result => {
        BotpressAPI.sendMessage({ botODM: botpressBotODM, key: assessmentUserKey }).then(
          response => {},
        );
      });

      // BotpressAPI.sendMessage({ botODM: botpressBotODM, key: assessmentUserKey }).then(response => {
      //
      // });
    }
  }, [assessmentConversationId, assessmentUserKey]);

  return <Fragment>{localAnswer.length === 0 ? "Asking the question..." : localAnswer}</Fragment>;
};

const mapStateToProps = state => ({
  botpressBotODM: state.botpressSession.botpressBotODM,

  assessmentConversationId: state.botpressSession.assessmentConversationId,
  assessmentUserKey: state.botpressSession.assessmentUserKey,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionForBotpressDisplay);
